import {SVGProps} from "types/SVG";

export const DamageClose = ({alt, className}: SVGProps) => (
    <svg width="165" height="165" viewBox="0 0 165 165" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <title>{alt}</title>
        <g clip-path="url(#clip0_3545_20851)">
            <path
                d="M165.217 121.876L-0.217712 121.876V6.00013C-0.217712 5.08897 0.521133 4.35013 1.4323 4.35013L163.567 4.35013C164.478 4.35013 165.217 5.08897 165.217 6.00013V121.876Z"
                fill="url(#paint0_linear_3545_20851)"/>
            <path d="M165.216 108.012H-0.21875V165.215H165.216V108.012Z" fill="url(#paint1_linear_3545_20851)"/>
            <mask id="mask0_3545_20851" maskUnits="userSpaceOnUse" x="-1" y="-1" width="167"
                  height="167">
                <path d="M165.216 -0.21875H-0.21875V165.216H165.216V-0.21875Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_3545_20851)">
                <path
                    d="M-8.185 82.2221L34.7095 88.8698L60.1965 67.0879L15.2542 12.1484L-7.51034 26.3329L-14.5137 63.2013L-8.185 82.2221Z"
                    fill="#2C3E54"/>
                <path
                    d="M79.4723 76.9099C67.8178 47.7141 46.652 28.8527 32.198 34.7836C26.8557 36.9762 7.52501 49.5529 7.09601 49.7821C-6.16632 56.8716 -7.94282 84.4779 3.34868 112.761C15.0032 141.957 36.169 160.818 50.623 154.887C55.9653 152.696 75.2502 140.202 75.6132 139.947C88.5657 130.88 90.795 105.272 79.4723 76.9099Z"
                    fill="#37556D"/>
                <path
                    d="M50.4466 154.96C64.9737 149.214 67.3771 120.858 55.8147 91.6249C44.2522 62.3916 23.1024 43.3514 8.57524 49.0972C-5.95192 54.843 -8.3553 83.1992 3.20715 112.432C14.7696 141.666 35.9194 160.706 50.4466 154.96Z"
                    fill="#4B6C8C"/>
                <path
                    d="M44.0199 138.709C54.0869 134.727 55.7523 115.077 47.7396 94.8184C39.7269 74.5601 25.0704 61.3653 15.0034 65.347C4.93634 69.3288 3.27095 88.9793 11.2836 109.238C19.2963 129.496 33.9528 142.691 44.0199 138.709Z"
                    fill="#37556D"/>
                <path
                    d="M40.2275 141.442C38.1631 141.442 35.987 140.971 33.7668 140.031C24.58 136.137 15.2776 124.715 9.48981 110.219C0.871315 88.6258 2.90448 68.1053 14.1208 63.5073C17.4263 62.1506 21.28 62.3284 25.2675 64.0151C34.4543 67.9091 43.7566 79.3326 49.5445 93.8288C58.163 115.422 56.1298 135.94 44.9135 140.54C43.4468 141.142 41.872 141.442 40.2256 141.442H40.2275ZM13.272 108.71C18.5886 122.027 27.2566 132.851 35.3563 136.283C38.363 137.557 41.0598 137.722 43.3716 136.775C52.19 133.157 53.2863 114.181 45.7641 95.3376C40.4475 82.0203 31.7795 71.1963 23.6798 67.7643C20.6731 66.4901 17.9781 66.3251 15.6663 67.2729C6.84798 70.8901 5.75165 89.8688 13.272 108.71Z"
                    fill="url(#paint2_linear_3545_20851)"/>
                <path
                    d="M34.8589 115.551C38.5705 114.083 39.1847 106.839 36.2308 99.3706C33.2769 91.9022 27.8734 87.0379 24.1618 88.506C20.4502 89.974 19.836 97.2184 22.79 104.687C25.7439 112.155 31.1473 117.019 34.8589 115.551Z"
                    fill="#4B6C8C"/>
                <path
                    d="M136.743 151.944C136.743 151.944 132.284 151.609 126.553 150.549C122.747 149.845 119.603 146.171 114.323 144.881C110.286 143.894 106.907 144.514 102.443 143.135C100.327 142.483 96.2372 140.838 94.0866 140.088C91.2981 139.117 88.737 139.802 85.9705 138.662C79.5685 136.024 75.1465 128.975 75.1465 121.561L143.427 144.23"
                    fill="#7196B5"/>
                <path
                    d="M234.733 95.0908L234.999 97.5731C235.307 100.439 234.167 104.677 232.222 106.3C224.038 113.122 213.81 118.655 191.619 132.342C184.32 136.845 174.09 142.944 165.023 146.411C154.006 150.622 146.768 151.741 136.736 151.944L144.48 141.005L234.732 95.0927L234.733 95.0908Z"
                    fill="#7196B5"/>
                <path
                    d="M76.2383 127.051L105.968 139.441C110.619 141.188 115.418 142.083 120.165 142.002C123.753 141.94 128.116 141.667 132.254 140.886L124.332 133.844L77.9634 123.276L76.2383 127.051Z"
                    fill="#7196B5"/>
                <path
                    d="M234.954 74.24V78.475C235.764 80.4458 236.186 82.5542 236.186 84.6405V92.9382C236.186 95.195 235.48 97.3015 234.133 98.8287C232.382 100.812 229.23 103.522 223.688 106.25L177.22 132.698C177.22 132.698 160.499 144 143.427 144.233L120.662 137.455L156.452 103.694L188.662 84.3637L230.818 64.2227C230.818 64.2227 234.426 67.1908 234.954 74.2418V74.24Z"
                    fill="#547B9B"/>
                <path
                    d="M232.603 63.1254C232.603 63.1254 235.243 56.3347 235.419 46.5062C235.419 46.5062 232.906 24.1029 222.267 22.748L169.854 46.6657L156.377 52.2427L105.08 65.3456L107.544 82.2177L151.546 90.3669L232.601 63.1254H232.603Z"
                    fill="url(#paint3_linear_3545_20851)"/>
                <path d="M112.094 99.9156L150.29 106.604L156.45 103.69L151.17 90.2429L107.166 82.0938L112.094 99.9156Z"
                      fill="url(#paint4_linear_3545_20851)"/>
                <path
                    d="M234.954 74.2397C234.954 74.2397 233.429 66.1896 230.73 67.0659L164.9 101.76L120.662 137.453L98.543 120.638L112.097 99.9174L145.947 105.777L153.636 99.8917L155.044 93.3559L228.618 54.0254L231.434 60.0552C231.434 60.0552 235.658 65.8504 234.954 74.2397Z"
                    fill="url(#paint5_linear_3545_20851)"/>
                <path
                    d="M153.634 99.8921C153.634 99.8921 157.858 95.8405 163.49 93.5249C169.122 91.2076 216.822 69.0353 228.087 59.8741C228.087 59.8741 229.671 58.4771 231.431 60.0556C231.431 60.0556 233.309 51.0778 232.253 47.1508C231.197 43.2238 229.437 37.2471 226.269 37.5459C224.049 37.7549 210.31 46.6374 199.632 51.7304C188.955 56.8234 173.817 61.2803 169.828 65.1614C165.301 69.5651 151.17 90.2433 151.17 90.2433L153.636 99.8939L153.634 99.8921Z"
                    fill="#547B9B"/>
                <path
                    d="M52.5389 48.5263C52.5389 48.5263 24.8593 28.8363 7.79827 23.1695C3.88044 21.8678 -0.0887318 23.0026 -2.69573 26.0918C-5.91873 29.9125 -10.2087 36.8755 -13.2337 48.8801C-14.1284 52.4313 -13.5601 56.4115 -11.6919 59.7811C-10.9439 61.1286 -8.25623 63.2168 -7.0334 64.9218L-7.7099 75.6541L-16.1579 69.9708L-18.3286 59.6876C-19.2526 55.3115 -19.7091 50.8931 -19.6761 46.5005C-19.5477 28.9298 -18.3872 -17.6699 -9.88056 -32.2559L16.9319 -26.0702L76.1889 19.0445L80.9409 43.2151L52.5389 48.5263Z"
                    fill="url(#paint6_linear_3545_20851)"/>
                <path
                    d="M60.5039 47.2333L61.9192 43.5519L79.2406 38.0996L113.722 69.0719L136.158 74.8726L146.009 77.0378L134.098 81.6303L83.8166 78.6621L60.5039 47.2333Z"
                    fill="url(#paint7_linear_3545_20851)"/>
                <path
                    d="M104.803 64.3336L102.209 64.3043C101.798 64.2988 101.386 64.1613 101.019 63.9065L89.7989 56.0836L79.5139 49.7036C79.2976 49.5698 79.1289 49.348 79.0464 49.0876L77.8621 45.3311C77.7044 44.8325 77.3139 44.4511 76.8574 44.3521L70.8532 43.0468L69.4141 22.0918L83.1182 41.12L104.803 64.3336Z"
                    fill="#2C3E54"/>
                <path
                    d="M156.685 56.8261C166.49 52.8606 201.248 36.9785 217.393 26.2131C219.422 24.8601 220.463 22.2586 220.044 19.483C219.55 16.2251 218.672 11.4951 217.182 6.36914C213.213 13.7685 210.391 15.6861 210.391 15.6861C195.62 26.4936 162.779 39.2995 153.648 42.7571C152.109 43.3401 150.573 43.8828 148.984 44.3081C147.279 44.7646 145.458 45.179 143.56 45.5566C143.208 45.6263 154.935 57.5356 156.685 56.828V56.8261Z"
                    fill="#4B6C8C"/>
                <path
                    d="M160.217 52.1129L155.155 64.6107C154.737 65.6429 154.061 66.4972 153.203 67.0784L142.998 73.9827C142.04 74.6317 140.839 74.7692 139.691 74.3585L116.201 65.9784L104.801 64.3339C103.881 64.2019 102.979 63.8279 102.17 63.2449L91.3424 55.433C91.2434 55.3615 91.1426 55.2937 91.0399 55.2277L80.7201 48.624C80.4928 48.4792 80.3241 48.2372 80.2544 47.9585L79.3176 44.2295C79.2058 43.7822 78.8629 43.4339 78.4596 43.3587L73.4088 42.4035C72.8826 42.3045 72.4481 41.8187 72.3564 41.2265L69.4121 22.0957L127.483 59.0025L160.215 52.1165L160.217 52.1129Z"
                    fill="url(#paint8_linear_3545_20851)"/>
                <path
                    d="M69.4141 22.0918C69.4141 22.0918 73.2274 36.8593 84.5702 47.841C88.0426 51.2033 85.8022 52.1585 93.4747 54.8333C96.4612 55.8746 101.895 59.8328 106.438 61.6936C107.918 62.3005 109.692 61.9521 111.309 62.5755C114.598 63.8441 117.93 66.0955 121.668 67.3256C126.576 68.9408 131.804 70.4606 137.172 71.7201C139.341 72.228 141.495 71.5661 143.015 69.9876L160.219 52.1126C160.219 52.1126 133.834 50.0886 109.456 41.5178C109.456 41.5178 81.1181 30.4316 69.4159 22.0918H69.4141Z"
                    fill="url(#paint9_linear_3545_20851)"/>
                <path
                    d="M112.094 99.9163L107.166 82.0945L96.6741 81.3887L88.0391 112.359L98.5422 120.639L112.094 99.9163Z"
                    fill="#2C3E54"/>
                <path
                    d="M16.9297 -26.069C24.263 -11.3932 35.2172 0.840683 48.3127 8.97885L69.4144 22.0927C91.341 35.7199 114.47 44.9415 138.971 49.1197L157.479 52.3794C158.425 52.5462 159.356 52.4582 160.218 52.1117C167.699 49.1105 205.45 33.7325 222.276 22.3622C224.073 21.1485 224.969 18.8018 224.608 16.3342C223.97 11.9635 222.593 4.60085 219.854 -2.78931C216.741 -11.186 211.204 -18.3763 204.276 -23.2512C191.654 -32.1318 162.333 -52.3297 134.626 -68.2852C134.626 -68.2852 144.482 -58.8985 126.882 -50.6485C109.28 -42.4003 53.6605 -25.4567 53.6605 -25.4567C53.6605 -25.4567 36.88 -22.2355 16.9315 -26.069H16.9297Z"
                    fill="url(#paint10_linear_3545_20851)"/>
                <path opacity="0.2"
                      d="M161.579 51.5662C171.383 47.6007 205.744 33.3906 221.89 22.6252C223.919 21.2722 224.961 18.6707 224.541 15.8951C224.048 12.6372 223.17 7.90725 221.679 2.78125C217.71 10.1806 214.888 12.0982 214.888 12.0982C200.117 22.9057 167.277 35.7116 158.145 39.1692C156.607 39.7522 155.07 40.2949 153.481 40.7202C151.776 41.1767 149.955 41.5911 148.058 41.9687C147.706 42.0384 160.576 52.1052 160.218 52.1712C151.967 53.7241 159.828 52.2739 161.579 51.5662Z"
                      fill="url(#paint11_linear_3545_20851)"/>
                <path
                    d="M146.008 77.0368C146.008 77.0368 137.615 78.1918 121.778 76.1641C110.239 74.6865 94.7202 69.6375 84.0703 63.4591L60.5047 47.2305L59.2012 56.0085C59.2012 56.0085 64.8882 64.6636 67.2202 72.2005L77.7105 106.088C79.0708 110.484 77.5235 115.034 74.0328 116.892L73.9595 116.93L76.5408 125.626C76.5408 125.626 80.5247 127.118 86.5178 129.067C90.146 130.246 94.7862 128.493 99.452 129.776C102.941 130.737 106.323 134.763 109.966 135.557C113.607 136.351 117.235 137.014 120.662 137.449C120.662 133.679 118.489 130.106 115.272 128.625C110.641 126.493 103.643 122.832 96.7607 117.552C94.2087 115.594 93.0665 112.002 93.9245 108.935L101.216 100.309L98.5757 92.2718C98.5445 83.6955 103.692 82.194 107.167 82.0913L126.919 84.4655L146.008 77.035V77.0368Z"
                    fill="url(#paint12_linear_3545_20851)"/>
                <path
                    d="M82.1408 68.1916C82.1408 68.1916 83.6606 63.9181 85.1621 61.7493C86.5719 59.7143 89.0909 57.9176 88.5538 57.6628C87.5216 57.1733 84.5901 58.7096 80.9106 59.4649C74.4774 60.7849 72.3324 61.1149 69.8409 60.7318C66.9516 63.6376 64.5371 67.1961 64.5371 67.1961C64.8799 68.8003 67.9013 72.8868 67.9013 72.8868C67.9013 72.8868 71.8833 93.1744 76.6408 89.7461C81.5504 86.2096 87.7324 95.8053 89.1789 94.4761C91.9289 91.9461 85.1181 81.2284 85.6039 80.5263C90.6511 73.2553 98.1824 67.0824 95.3444 64.7706C93.1169 62.9556 82.1408 68.1898 82.1408 68.1898V68.1916Z"
                    fill="url(#paint13_linear_3545_20851)"/>
                <path
                    d="M80.9376 56.1379C81.2071 57.2489 80.9742 59.909 80.9742 59.909C80.9742 59.909 81.3207 58.0775 82.5729 56.4275C83.7481 54.8802 85.8472 53.5144 85.3999 53.3219C84.5401 52.9497 82.6921 53.3769 79.8852 54.6419C79.7661 54.695 77.9492 55.5769 77.8301 55.6264C78.6129 55.5127 80.8459 55.762 80.9376 56.1379Z"
                    fill="url(#paint14_linear_3545_20851)"/>
                <path
                    d="M70.8036 54.3887C68.7007 56.3173 65.0561 60.435 64.6344 60.9905C64.5849 61.062 64.5482 61.1115 64.5391 61.1152C65.0029 61.1372 66.1451 63.361 66.8362 64.7947C67.1351 65.1833 67.3441 65.4418 67.3441 65.4418C67.3441 65.4418 67.3771 65.572 67.4394 65.8067C67.6649 64.9762 68.7081 61.3828 70.1729 60.2883C74.1384 57.3238 77.8344 55.6262 77.8344 55.6262C73.5444 55.6427 71.7954 55.2137 70.8054 54.3887H70.8036Z"
                    fill="url(#paint15_linear_3545_20851)"/>
                <path
                    d="M71.7521 76.7408C70.0122 71.3783 64.5379 59.3828 64.5379 59.3828L59.5292 53.1807L59.1992 56.0132L61.8557 68.0362C61.8557 68.0362 64.3821 74.5812 65.0366 76.5978C69.2056 89.4513 74.0639 100.38 74.6542 113.858L86.5177 129.071C88.3584 129.561 92.8519 129.616 92.8519 129.616C92.8519 129.616 75.6827 88.8647 71.7502 76.7408H71.7521Z"
                    fill="#2C3E54"/>
                <path
                    d="M52.7119 49.032C43.6571 41.4016 26.9389 28.9973 7.01795 22.1186C3.36778 20.8573 -0.388717 21.906 -2.83072 24.7806C-6.69905 29.3346 -11.9846 37.8853 -14.3679 52.2715C-14.6832 54.1745 -14.2469 56.2223 -13.2312 57.9493C-11.4089 61.0458 -8.49022 65.8235 -7.15188 67.017C-7.15188 67.017 -6.38738 48.0346 1.20445 36.0813C2.87095 33.456 6.01145 32.598 8.90995 33.8648C15.1561 36.5928 39.6495 50.8616 39.6495 50.8616L52.7119 49.0301V49.032Z"
                    fill="#7196B5"/>
                <path
                    d="M109.454 41.518C109.454 41.518 99.1249 37.4755 88.3633 32.4375L90.9464 39.2465C92.2096 42.5777 94.6736 45.2488 97.6784 46.5193C108.292 51.0073 134.308 61.2043 151.533 61.1347L160.217 52.111C160.217 52.111 133.832 50.087 109.454 41.518Z"
                    fill="#4B6C8C"/>
                <path
                    d="M160.219 52.1135L146.483 53.0851L121.416 45.2055L131.356 44.3291C132.038 44.2796 132.739 44.4391 133.384 44.793L140.096 48.4706C140.479 48.6815 140.884 48.8245 141.297 48.8941L160.219 52.1153V52.1135Z"
                    fill="url(#paint16_linear_3545_20851)"/>
                <path
                    d="M16.9297 -26.0684L85.104 3.72697L98.8559 22.1355L81.0249 6.69331L48.6555 9.0913L46.285 7.33314C34.5664 -1.36236 24.5215 -12.7932 16.9297 -26.0684Z"
                    fill="url(#paint17_linear_3545_20851)"/>
                <path
                    d="M48.6561 9.09136L81.0255 6.69336L98.8345 22.0824L101.946 30.9795L120.077 39.9299L121.419 45.2044C121.419 45.2044 111.556 43.2885 88.3166 32.7817C72.6471 25.6977 55.9711 15.156 48.6543 9.09136H48.6561Z"
                    fill="url(#paint18_linear_3545_20851)"/>
                <path
                    d="M111.311 62.5781L120.191 58.5521L124.621 65.704L141.106 59.8538L131.855 52.4691L122.378 51.7725L111.311 62.5781Z"
                    fill="white"/>
                <path
                    d="M98.3641 46.8066L94.1914 48.5593L97.5941 51.3295L93.4746 54.8366L95.2841 55.6396L101.268 52.5065L98.1844 48.8086L103.144 48.7573L98.3641 46.8066Z"
                    fill="url(#paint19_linear_3545_20851)"/>
                <path d="M111.311 62.5781L123.625 49.3066L128.549 50.6138L111.311 62.5781Z" fill="#4B6C8C"/>
                <path d="M132.263 44.3483L119.609 39.6953L121.426 45.2063L132.263 44.3483Z"
                      fill="url(#paint20_linear_3545_20851)"/>
                <path
                    d="M63.7807 43.7277L70.8555 43.0476L70.6758 40.4332L60.6823 35.1624L54.0383 38.3231L48.0947 32.9551L42.8477 40.5781L43.1557 50.5606L60.1085 49.8841L60.5027 47.2331L63.7807 43.7277Z"
                    fill="url(#paint21_linear_3545_20851)"/>
                <path
                    d="M39.6406 50.8768L38.1152 37.9372L46.4752 27.4102L54.3641 34.5987L60.2014 29.964L70.4882 37.7025L70.6716 40.4323L61.2519 36.3788L56.0471 40.084L48.0006 35.8783L43.1569 40.8687V50.5615L39.6406 50.8768Z"
                    fill="url(#paint22_linear_3545_20851)"/>
                <path
                    d="M46.4748 27.4095L32.2719 12.7832L25.3548 11.6319L9.32227 -3.32812L9.80443 3.08121L24.6874 16.1584L29.6466 16.2812L46.4748 27.4095Z"
                    fill="url(#paint23_linear_3545_20851)"/>
                <path d="M9.80463 3.08143L-16.8594 -4.37107L-15.6329 -13.1289L9.32246 -3.32791L9.80463 3.08143Z"
                      fill="url(#paint24_linear_3545_20851)"/>
                <path d="M98.5763 92.2744L85.6055 80.5264L93.9251 108.939L101.216 100.314L98.5763 92.2744Z"
                      fill="#F09063"/>
                <path
                    d="M16.9297 -26.0684C16.9297 -26.0684 44.866 11.8908 88.3197 32.7816C88.3197 32.7816 33.4774 10.3196 16.9315 -26.0684H16.9297Z"
                    fill="#4B6C8C"/>
                <path
                    d="M57.3086 13.6815L77.7319 24.7585L88.3176 32.7794C88.3176 32.7794 72.7434 26.0015 62.3301 19.1302C60.0348 17.6159 57.9521 14.7064 57.3086 13.6797V13.6815Z"
                    fill="#2C3E54"/>
                <path
                    d="M56.0629 14.3991L76.7227 24.7611L88.3204 32.7819L77.8594 24.2551L49.373 7.98242L56.0629 14.3991Z"
                    fill="#4B6C8C"/>
                <path
                    d="M88.3202 32.7805L93.47 32.7695L99.6484 36.3555C101.793 37.6004 106.109 37.978 108.371 38.8287L121.425 45.2032C121.425 45.2032 107.37 42.235 88.3184 32.7805H88.3202Z"
                    fill="url(#paint25_linear_3545_20851)"/>
                <path d="M98.8359 22.082L128.254 26.229L160.394 51.9745L124.118 31.2322L98.8359 22.082Z"
                      fill="url(#paint26_linear_3545_20851)"/>
                <path d="M119.611 39.6985L124.118 31.2322L98.8359 22.082L101.947 30.9792L119.611 39.6985Z"
                      fill="url(#paint27_linear_3545_20851)"/>
                <path d="M128.253 26.2285L124.117 31.2317L160.217 52.1133L128.253 26.2285Z"
                      fill="url(#paint28_linear_3545_20851)"/>
                <path
                    d="M32.2719 12.7832L35.1283 15.6542L45.1328 15.8229L49.1184 10.3119L45.9816 8.02387L29.1919 7.34554L9.32227 -3.32812L25.3548 11.6319L32.2719 12.7832Z"
                    fill="url(#paint29_linear_3545_20851)"/>
                <path
                    d="M66.8333 69.2786C64.8423 64.5137 63.1299 60.7371 59.1993 56.0107L51.0098 65.9437C54.2273 68.4572 58.7171 75.3286 60.2204 79.3381L76.5499 128.453L86.7689 129.337C86.7689 129.337 74.9219 88.6386 66.8351 69.2767L66.8333 69.2786Z"
                    fill="#7196B5"/>
                <path
                    d="M129.772 60.1139L131.129 55.7597L129.853 52.2929L126.458 53.7577L127.006 50.6025L111.311 62.5779L113.237 63.049L119.396 61.3184L120.386 63.2965L129.772 60.1139Z"
                    fill="white"/>
                <path
                    d="M126.694 57.1836L129.853 52.2923L128.139 47.2305L111.311 62.5773L124.166 54.1733L124.588 57.7245L126.694 57.1836Z"
                    fill="white"/>
                <path
                    d="M126.694 57.1843L124.588 57.7251L124.166 54.174L111.311 62.578L122.789 56.3318V60.0095L127.686 58.3485L129.853 52.293L126.694 57.1843Z"
                    fill="url(#paint30_linear_3545_20851)"/>
                <path
                    d="M96.8294 70.2155C99.7994 71.0405 105.408 78.4636 105.408 78.4636C106.398 73.0205 101.145 67.0383 101.145 67.0383C101.145 67.0383 106.447 69.7773 106.157 69.3061C102.621 63.5403 90.2532 55.8605 90.2532 55.8605C90.2532 55.8605 85.7029 53.3341 85.4004 53.3213C86.2382 53.9941 94.8531 62.2423 95.3444 64.7705C95.5699 65.931 85.6039 80.5261 85.6039 80.5261C85.6039 80.5261 95.4031 72.7675 96.8294 70.2155Z"
                    fill="url(#paint31_linear_3545_20851)"/>
            </g>
            <path
                d="M114.036 52.8566L115.772 48.6895L103.162 48.7756C106.31 50.0315 110.015 51.445 114.034 52.8566H114.036Z"
                fill="#89A6BD"/>
            <path
                d="M114.037 52.8564C110.018 51.4447 106.313 50.0294 103.165 48.7754L98.1857 48.8084L101.269 52.5081L95.2891 55.6394L102.474 60.0211C103.4 60.5857 104.39 61.0386 105.422 61.3704L106.439 61.6967L106.142 56.6001L112.317 56.9814L114.037 52.8564Z"
                fill="#E3F1FE"/>
        </g>
        <defs>
            <linearGradient id="paint0_linear_3545_20851" x1="82.4986" y1="-9.6052" x2="82.4986" y2="87.8218"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#ECFFFF"/>
                <stop offset="0.46" stop-color="#F0FCFF"/>
                <stop offset="1" stop-color="#FFF4FF"/>
            </linearGradient>
            <linearGradient id="paint1_linear_3545_20851" x1="82.4994" y1="227.582" x2="82.4994" y2="83.8099"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#ECFFFF"/>
                <stop offset="0.3" stop-color="#E8FAFF"/>
                <stop offset="0.66" stop-color="#DEEBFF"/>
                <stop offset="1" stop-color="#CFD7FF"/>
            </linearGradient>
            <linearGradient id="paint2_linear_3545_20851" x1="-7.05271" y1="97.0933" x2="43.6452" y2="103.75"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint3_linear_3545_20851" x1="205.558" y1="31.5532" x2="80.6563" y2="95.1138"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint4_linear_3545_20851" x1="122.143" y1="101.653" x2="128.532" y2="52.9943"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint5_linear_3545_20851" x1="90.5566" y1="84.6105" x2="226.986" y2="102.523"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint6_linear_3545_20851" x1="-21.1754" y1="20.0581" x2="79.4002" y2="33.2634"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint7_linear_3545_20851" x1="126.955" y1="59.8649" x2="41.4482" y2="59.8649"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.31" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint8_linear_3545_20851" x1="71.6634" y1="42.5887" x2="155.762" y2="57.0794"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint9_linear_3545_20851" x1="66.5252" y1="42.0663" x2="157.288" y2="53.9831"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint10_linear_3545_20851" x1="321.215" y1="-26.2143" x2="-15.7163" y2="-14.9986"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint11_linear_3545_20851" x1="100.788" y1="50.4126" x2="381.202" y2="14.5151"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint12_linear_3545_20851" x1="50.2449" y1="86.9452" x2="137.016" y2="98.338"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint13_linear_3545_20851" x1="64.5389" y1="76.0859" x2="95.9659" y2="76.0859"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint14_linear_3545_20851" x1="85.1047" y1="55.4999" x2="50.4419" y2="68.3809"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.31" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint15_linear_3545_20851" x1="98.4869" y1="54.6417" x2="34.5916" y2="66.5125"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.31" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint16_linear_3545_20851" x1="72.5889" y1="37.2268" x2="156.688" y2="51.7175"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint17_linear_3545_20851" x1="41.2914" y1="-6.61809" x2="195.177" y2="27.1257"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint18_linear_3545_20851" x1="3.11277" y1="14.5098" x2="174.884" y2="35.3693"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#4B6C8C"/>
                <stop offset="0.03" stop-color="#507196"/>
                <stop offset="0.1" stop-color="#5E81B0"/>
                <stop offset="0.18" stop-color="#698EC6"/>
                <stop offset="0.27" stop-color="#7298D7"/>
                <stop offset="0.39" stop-color="#789EE3"/>
                <stop offset="0.55" stop-color="#7CA2EA"/>
                <stop offset="1" stop-color="#7DA4EC"/>
            </linearGradient>
            <linearGradient id="paint19_linear_3545_20851" x1="99.5356" y1="50.5466" x2="163.475" y2="34.582"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint20_linear_3545_20851" x1="116.698" y1="42.0947" x2="163.121" y2="45.2801"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#4B6C8C"/>
                <stop offset="0.03" stop-color="#507196"/>
                <stop offset="0.1" stop-color="#5E81B0"/>
                <stop offset="0.18" stop-color="#698EC6"/>
                <stop offset="0.27" stop-color="#7298D7"/>
                <stop offset="0.39" stop-color="#789EE3"/>
                <stop offset="0.55" stop-color="#7CA2EA"/>
                <stop offset="1" stop-color="#7DA4EC"/>
            </linearGradient>
            <linearGradient id="paint21_linear_3545_20851" x1="88.7635" y1="34.2531" x2="38.3798" y2="44.6701"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint22_linear_3545_20851" x1="71.1647" y1="33.528" x2="-28.4201" y2="54.1585"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.03" stop-color="#C45519"/>
                <stop offset="0.08" stop-color="#B0643E"/>
                <stop offset="0.14" stop-color="#9F725E"/>
                <stop offset="0.2" stop-color="#907D79"/>
                <stop offset="0.27" stop-color="#85868F"/>
                <stop offset="0.35" stop-color="#7B8DA0"/>
                <stop offset="0.46" stop-color="#7592AC"/>
                <stop offset="0.6" stop-color="#7295B3"/>
                <stop offset="0.99" stop-color="#7196B5"/>
            </linearGradient>
            <linearGradient id="paint23_linear_3545_20851" x1="53.4506" y1="20.2669" x2="3.4446" y2="4.16654"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint24_linear_3545_20851" x1="55.3685" y1="14.3069" x2="5.36429" y2="-1.79157"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint25_linear_3545_20851" x1="73.2979" y1="33.1032" x2="157.397" y2="47.5939"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint26_linear_3545_20851" x1="95.7495" y1="27.0111" x2="224.752" y2="54.2977"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.07" stop-color="#8DB1EF" stop-opacity="0.8"/>
                <stop offset="0.15" stop-color="#9BBDF3" stop-opacity="0.61"/>
                <stop offset="0.23" stop-color="#A9C7F6" stop-opacity="0.45"/>
                <stop offset="0.32" stop-color="#B4D0F9" stop-opacity="0.31"/>
                <stop offset="0.42" stop-color="#BDD8FB" stop-opacity="0.2"/>
                <stop offset="0.52" stop-color="#C4DDFC" stop-opacity="0.11"/>
                <stop offset="0.64" stop-color="#C9E1FE" stop-opacity="0.05"/>
                <stop offset="0.78" stop-color="#CCE4FE" stop-opacity="0.01"/>
                <stop offset="1" stop-color="#CDE5FF" stop-opacity="0"/>
            </linearGradient>
            <linearGradient id="paint27_linear_3545_20851" x1="96.743" y1="49.3428" x2="142.917" y2="-0.856773"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint28_linear_3545_20851" x1="122.383" y1="22.2096" x2="161.716" y2="50.8305"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.07" stop-color="#8DB1EF" stop-opacity="0.8"/>
                <stop offset="0.15" stop-color="#9BBDF3" stop-opacity="0.61"/>
                <stop offset="0.23" stop-color="#A9C7F6" stop-opacity="0.45"/>
                <stop offset="0.32" stop-color="#B4D0F9" stop-opacity="0.31"/>
                <stop offset="0.42" stop-color="#BDD8FB" stop-opacity="0.2"/>
                <stop offset="0.52" stop-color="#C4DDFC" stop-opacity="0.11"/>
                <stop offset="0.64" stop-color="#C9E1FE" stop-opacity="0.05"/>
                <stop offset="0.78" stop-color="#CCE4FE" stop-opacity="0.01"/>
                <stop offset="1" stop-color="#CDE5FF" stop-opacity="0"/>
            </linearGradient>
            <linearGradient id="paint29_linear_3545_20851" x1="42.6248" y1="-4.03946" x2="15.9021" y2="13.8135"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint30_linear_3545_20851" x1="103.557" y1="61.8336" x2="178.28" y2="43.1777"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint31_linear_3545_20851" x1="111.843" y1="79.9211" x2="46.6841" y2="47.7223"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.31" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <clipPath id="clip0_3545_20851">
                <rect width="165" height="165" rx="8" fill="white"/>
            </clipPath>
        </defs>
    </svg>
);
